import { Warning } from '@mui/icons-material'
import { Alert, Typography } from '@mui/material'

import useStyles from './index.styles'

interface IProps {
  count: number
}

const UrgentAlertsBanner = ({ count }: IProps) => {
  const classes = useStyles

  return (
    <Alert severity="error" icon={<Warning sx={classes.urgentAlertsBannerIcon} />} sx={classes.urgentAlertsBanner}>
      <Typography variant="subtitle2" sx={classes.urgentAlertsBannerText}>
        {count} Alert{count !== 1 ? 's' : ''} Need{count !== 1 ? '' : 's'} Response
      </Typography>
    </Alert>
  )
}

export default UrgentAlertsBanner
